export const log = (...args) => {
  return process.env.NODE_ENV === "development" && console.log(...args);
};

export const warn = (...args) => {
  return process.env.NODE_ENV === "development" && console.warn(...args);
};

export const error = (...args) => {
  return console.error(...args);
};

export const info = (...args) => {
  return process.env.NODE_ENV === "development" && console.info(...args);
};
